


















































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';

import DataPanel from '@/components/DataPanel.vue';
import { Cap } from '@/http';
import { formRules } from '@/common/util/validator';
@Component({
    components: { BaseContainer, DataPanel, PageDescribe, BaseInfoPanel },
})
export default class DepartManagement extends Vue {
    public $refs: {
        vtree: HTMLFormElement;
    };
    filterNode(value, data) {
        console.log('data----->>>', JSON.stringify(data));
        console.log('value----->>>', JSON.stringify(value));
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    }

    filterChange() {
        this.loadData(this.searchValue.name);
    }

    public treeData = [];
    // 验证规则
    public formRules = formRules;
    public detailTitle: string = '';
    public eTitle: string = '';
    public dialogFormAdd: boolean = false;
    public searchValue: any = {
        name: '',
    };
    public authFormAdd: any = {
        type: '',
        systemType: '',
        name: '',
        value: '',
        value2: '',
        boolData: true,
        remarks: '',
        sort: '',
        id: '',
    };
    isdd: any = false;
    public bei: any = {};
    public labelPosition: string = 'left';
    public defaultProp = {
        label: 'name',
        children: 'childrenList',
    };
    public bm: boolean = false;
    // public yg: boolean = false;
    mounted() {
        this.bei = Object.assign({}, this.authFormAdd);
        this.loadData('');
    }

    async loadData(datas) {
        let res = await Cap.GetList({ keyWords: datas });
        console.log('res', res);
        let data = res.dicTypeVMs;
        let xxs = [];
        data.forEach((dd, index) => {
            dd.name = dd.type;
            dd.idd = dd.id;
            dd.id = 1;
            if (dd.dicList) {
                dd.dicList.forEach((dds) => {
                    dds.idd = dds.id;
                    dds.id = 2;
                    // dds.name = dds.type
                });
                dd.childrenList = dd.dicList;
            }
            xxs.push(dd);
        });
        console.log(xxs,'xxs');
        this.treeData = xxs;
    }

    // 新增权限
    public NodeAdd(node, data) {
        this.authFormAdd.type = '';
        this.dialogFormAdd = true;
        //     this.curTreeData = data;
        // }
    }

    // 编辑权限
    public NodeEdit(node, data) {
        this.isdd = false;
        console.log('data=.', data);
        console.log('node----->.', data);
        Object.keys(this.authFormAdd).forEach((key) => {
            this.authFormAdd[key] = data[key];
        });
        this.authFormAdd.id = data.idd;
        if (data.id == '2') {
            this.idds = 2;
            this.detailTitle = '编辑';
        } else {
            this.idds = 1;
            this.detailTitle = '编辑';
        }
    }

    // 删除权限
    public NodeDel(node, data) {
        if (node.level != 1) {
            this.$confirm('是否删除？')
                .then(async (e) => {
                    const parent = node.parent;
                    const children = parent.data.childrenList || parent.data;
                    const index = children.findIndex((d) => d.name === data.name);
                    children.splice(index, 1);
                    await Cap.DeleteDicName({ id: data.idd });
                    this.$alert('删除成功');
                    // Public.EditPermissionTree({ id: this.perId, type: 1, permissions: this.treeData })
                    //     .then((response) => {
                    //         this.$message({
                    //             type: 'success',
                    //             message: '删除成功！',
                    //         });
                    //         this.init();
                    //     })
                    //     .catch((error) => {});
                })
                .catch(() => {});
        } else {
            if (data.dicList) {
                this.$message({
                    type: 'info',
                    message: '该项无法删除！',
                });
            }
        }
    }
    public async submitAdd() {
        this.authFormAdd.isAdd = true;
        console.log(this.authFormAdd);
        this.isdd = false;
        if (this.detailTitle == '新增') {
            let res = await Cap.AddOrEditDicType(this.authFormAdd);
            this.$alert('添加成功');
        } else {
            let data = {
                id: this.authFormAdd.id,
                name: this.authFormAdd.name,
                type: this.authFormAdd.type,
                value: this.authFormAdd.value,
                value2: this.authFormAdd.value2,
                boolData: this.authFormAdd.boolData,
                sort: this.authFormAdd.sort,
                systemType: this.authFormAdd.systemType,
                remarks: this.authFormAdd.remarks,
            };
            let res = await Cap.EditOrEditDicType(data);
            this.$alert('编辑成功');
        }
        await this.loadData(this.searchValue.name);
        this.detailTitle = '';
    }
    public handleCloseAdd() {
        this.detailTitle = '';
    }

    public addDepartment(node, data) {
        this.isdd = false;
        console.log('data=.', data, node);
        this.authFormAdd = Object.assign({}, this.bei);
        if (data) {
            this.idds = 2;
            this.authFormAdd.type = data.type;
            this.authFormAdd.systemType = data.systemType;
        } else {
            this.idds = 1;
        }
        this.detailTitle = '新增';
    }
    public idds: any = 0;
    public viewDetail(node, data) {
        this.isdd = true;
        console.log('data=.', JSON.stringify(data));
        console.log('node----->.', JSON.stringify(data));
        if (data.id == '1') {
            this.detailTitle = '类目详情';
            this.idds = 1;
        } else {
            this.detailTitle = '字典项详情';
            this.idds = 2;
        }
        Object.keys(this.authFormAdd).forEach((key) => {
            this.authFormAdd[key] = data[key];
        });
        this.authFormAdd.id = data.idd;
    }
}
